import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { HOLDING_DATA, } from "@frameworks/web/redux/interfaces/Reports/iAccountOverview";
const initHoldingData = {
    holdingData: {
        holdingSummary: {
            date: "",
            message: "",
            totalInvestment: "",
            currentValue: "",
            totalPnL: "",
            daysPnL: "",
            totalPnLChange: "",
            daysPnLChange: "",
        },
        holdingDetails: [],
    },
};
const holdingReducer = (state = initHoldingData, action) => {
    switch (action.type) {
        case HOLDING_DATA:
            return Object.assign(Object.assign({}, state), { holdingData: action.payload.holdingData });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: holdingReducer,
    commonData: commonOnePlatFormReducer,
});
